import { useState, useEffect, useCallback } from 'react';
import notificationService from '../services/NotificationService';

export const useNotifications = () => {
  const [permissionStatus, setPermissionStatus] = useState(() => 
    notificationService.getPermissionStatus()
  );

  // Update permission status
  const updatePermissionStatus = useCallback(() => {
    setPermissionStatus(notificationService.getPermissionStatus());
  }, []);

  // Request notification permission
  const requestPermission = useCallback(async () => {
    const granted = await notificationService.requestPermission();
    updatePermissionStatus();
    return granted;
  }, [updatePermissionStatus]);

  // Show message notification
  const showMessageNotification = useCallback((messageData, roomData = {}, fallbackCallback = null) => {
    return notificationService.showMessageNotification(messageData, roomData, fallbackCallback);
  }, []);

  // Show notification only if tab is inactive
  const showNotificationIfInactive = useCallback((messageData, roomData = {}, fallbackCallback = null) => {
    return notificationService.showNotificationIfTabInactive(messageData, roomData, fallbackCallback);
  }, []);

  // Show custom notification
  const showCustomNotification = useCallback((title, message, options = {}) => {
    return notificationService.showCustomNotification(title, message, options);
  }, []);

  // Check if tab is active
  const isTabActive = useCallback(() => {
    return notificationService.isTabActive();
  }, []);

  // Initialize notifications
  const initialize = useCallback(async () => {
    const result = await notificationService.initialize();
    updatePermissionStatus();
    return result;
  }, [updatePermissionStatus]);

  // Listen for permission changes
  useEffect(() => {
    // Update status when tab becomes visible
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        updatePermissionStatus();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [updatePermissionStatus]);

  return {
    // Status
    permissionStatus,
    isEnabled: permissionStatus.isEnabled,
    isSupported: permissionStatus.isSupported,
    permission: permissionStatus.permission,
    
    // Actions
    requestPermission,
    initialize,
    updatePermissionStatus,
    
    // Notification methods
    showMessageNotification,
    showNotificationIfInactive,
    showCustomNotification,
    
    // Utility
    isTabActive,
  };
};